module.exports = __webpack_public_path__ + "img/paisajerecuperaciondecontrasenadesktop.8f781a96.jpg";